import { useState, useMemo, useRef, useEffect } from "react"
import { useRequest } from "ahooks";
import { Card, Button, Modal, Form, Select, Input, message } from "antd";
import { EditForm } from "../../../components/editForm";
import { Table, DEFAULT_PAGE_DATA } from "../../../components/table";
import { DEFAULT_QUERY_DATA, generateQueryFormConfig, generateTableColumns } from "./config";
import { AmountServer } from "../../../server";
import dayjs from "dayjs";

const server = AmountServer.Usertransfer

export const UserTransfer = () => {
    const [loading, setLoading] = useState<boolean>(false);
    const [showQueryAccount, setShowQueryAccount] = useState<boolean>(false);
    const [queryData, setQueryData] = useState<any>({ ...DEFAULT_QUERY_DATA });
    const [tableData, setTableData] = useState<any[]>([]);
    const [pageData, setPageData] = useState<any>({ ...DEFAULT_PAGE_DATA });
    const [form] = Form.useForm();

    //获取表格数据
    const { run, refresh } = useRequest(server.list, {
        defaultParams: [{ ...pageData }],
        onBefore: () => setLoading(true),
        onFinally: () => setLoading(false),
        onError: () => {
            setTableData([]);
            setPageData({ ...pageData, Total: 0 });
        },
        onSuccess: (res: any) => {
            const { Total, List, Page, PageSize } = res;
            setTableData(List);
            setPageData({ Page, PageSize, Total });
        }
    });

    const getQueryFormConfig = useMemo(() => {
        return generateQueryFormConfig();
    }, []);

    const getTableColumns = useMemo(() => {
        return generateTableColumns();
    }, []);

    const formatQueryDate = () => {
        let { DateStart, DateEnd, ...otherData } = queryData;
        const format = 'YYYYMMDD'
        DateStart = DateStart ? dayjs(DateStart).startOf('day').format(format) : null;
        DateEnd = DateEnd ? dayjs(DateEnd).endOf('day').format(format) : null;
        return { ...otherData, DateStart, DateEnd };
    };
    return (
        <div>
            <Card>
                <div className="flex space-between align-center ">
                    <EditForm
                        componentId="recharge-query-form"
                        loading={loading}
                        formAttrsProps={{
                            layout: 'inline',
                        }}
                        formData={queryData}
                        onDataChange={setQueryData}
                        formConfig={getQueryFormConfig}
                        onQuery={() => {
                            run({ ...DEFAULT_PAGE_DATA, ...formatQueryDate() });
                        }}
                        onReset={() => {
                            setQueryData({ ...DEFAULT_QUERY_DATA });
                            run({ ...DEFAULT_QUERY_DATA, ...DEFAULT_PAGE_DATA });
                        }}
                    />
                </div>
            </Card>
            <Card className="mt20">
                <Table
                    loading={loading}
                    dataSource={tableData}
                    columns={getTableColumns}
                    rowKey="Id"
                    scroll={{
                        x: 'max-content'
                    }}
                    page={pageData}
                    onPageChange={(Page: number, PageSize: number) => {
                        const currentPage = { ...pageData, Page, PageSize };
                        run({ ...currentPage, ...formatQueryDate() });
                    }}
                />
            </Card >
        </div>
    );
}